import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';


@Injectable({
  providedIn: 'root'
})
export class ModalService {
  result: Subject<boolean>;

  constructor(private matDialog: MatDialog) {
    this.result = new Subject<boolean>();
  }

  show<T>(modal: any, options: any = {}, width: string = '800px'): MatDialogRef<T> {
    return this.matDialog.open(modal, {width: width, ...options});
  }

  close() {
    this.matDialog.closeAll();
  }
}
